module.exports = __webpack_public_path__ + "static/media/01C.1bf45848.png";